import React, { SetStateAction, useCallback, useEffect, useState } from 'react';
import { ReactComponent as Close } from 'assets/header/close.svg'
import { jsonAxios } from 'components/axios';
import { INotiDetail } from 'types/noti';
import { getToday } from 'components/function';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

interface IConfrimDialog {
    isOpen: boolean,
    setIsOpen: React.Dispatch<SetStateAction<boolean>>,
}

const NoticeModal = ({ isOpen, setIsOpen }: IConfrimDialog) => {
    const [list, setList] = useState<INotiDetail[]>([]);
    const [isExist, setIsExist] = useState<boolean>(false);

    const getNoticeList = useCallback(() => {
        jsonAxios.get(`notice/main`).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                setList(res.data.data)
                setIsExist(true)
            }
            else if (res.data.code === 201) {
                setIsExist(false)
            }
        })
    }, []);

    useEffect(() => {
        if (isOpen) {
            getNoticeList();
        }
    }, [isOpen, getNoticeList])

    const handleCloseToday = () => {
        const today = getToday();
        localStorage.setItem('isNotice', today);
        setIsOpen(p => !p);
    };

    if (!isOpen) return null;
    if (!isExist) return null;

    return (
        <div className="relative">
            <div className="z-50 fixed inset-0 flex flex-col justify-center items-center gap-4 bg-black bg-opacity-50">
                <div className="relative bg-white shadow-lg px-10 mobile:px-6 rounded-lg w-[800px] mobile:w-9/10 tablet:w-96 h-[740px] mobile:h-9/10 select-text" onClick={(e) => {
                    e.stopPropagation();
                }}>
                    <Close className='top-4 right-4 absolute mobile:w-6 mobile:h-6 cursor-pointer' onClick={() => setIsOpen(false)} />
                    <Swiper
                        className='w-full h-full'
                        slidesPerView={1}
                        spaceBetween={50}
                        modules={[Pagination]}
                        loop
                        pagination={{ clickable: true }}
                    >
                        {
                            list?.map((item, idx) => (
                                <SwiperSlide
                                    className='flex flex-col gap-10 h-full mobile:text-base text-lg text-left'
                                    key={idx}
                                >
                                    <div className='flex justify-between items-center py-6 border-[#F8F8FA] border-b-2'>
                                        <div className='leading-none'>
                                            <p className='text-[#9D9EB7]'>{item.createAt}</p>
                                            <p className='font-semibold mobile:text-xl text-2xl'>{item.title}</p>
                                        </div>
                                    </div>

                                    <div className='flex flex-col justify-between gap-10 pb-10 h-full min-h-[400px] overflow-y-auto'>
                                        <div className='flex-1' dangerouslySetInnerHTML={{ __html: item.content }} />
                                    </div>
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                </div>
                <div
                    className='cursor-pointer'
                    onClick={handleCloseToday}
                >
                    <p className='text-white text-xl'>오늘 하루 안 보기</p>
                </div>
            </div>
        </div>
    );
};

export default NoticeModal;